import { onUnmounted, ref } from 'vue'

export default function useObservers() {
  const observer = ref()

  onUnmounted(() => {
    observer.value?.disconnect()
  })

  function initializeResizeObserver(target: Element, callback: any) {
    observer.value = new ResizeObserver((entries) => {
      entries.forEach(({ contentBoxSize }) => contentBoxSize[0].inlineSize > 0 && callback())
    })
    observer.value?.observe(target)
  }

  function initializeIntersectionObserver(target: Element, callback: () => void, root?: Element) {
    const options = {
      root: root ?? null,
      threshold: 0.5
    }

    observer.value = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          callback()
        }
      })
    }, options)

    observer.value?.observe(target)
  }

  return { observer, initializeResizeObserver, initializeIntersectionObserver }
}
